import { useAuthContext } from "../AuthProvider";
import { getLoginHeader } from "../userAssests";

const MicrosoftLogo = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mr-2"
  >
    <rect width="10" height="10" fill="#F25022" />
    <rect x="14" width="10" height="10" fill="#7FBA00" />
    <rect y="14" width="10" height="10" fill="#00A4EF" />
    <rect x="14" y="14" width="10" height="10" fill="#FFB900" />
  </svg>
);

export const LoginForm = () => {
  const { loginWithMicrosoft } = useAuthContext();
  return (
    <div className="relative flex flex-col justify-center h-screen overflow-hidden bg-gray-200">
      <div className="w-full p-6 m-auto bg-white rounded-md shadow-md lg:max-w-lg">
        {getLoginHeader()}
        <button
          type="button"
          className="btn w-full mt-2 flex items-center justify-center bg-white text-gray-800 border border-gray-300 hover:bg-gray-100"
          onClick={loginWithMicrosoft}
        >
          <MicrosoftLogo />
          <span>Login with Microsoft</span>
        </button>
      </div>
    </div>
  );
};
